"use client";

import { Typography } from "@/components/ui/typography";
import Carousel, { CarouselSlide } from "@/components/ui/carousel";
import type { ServicesTrustedExpertiseProps } from "./types";
import { servicesTrustedExpertisePropsMap } from "./constants";
import type { ServiceCardSmallProps } from "@/components/screen/global-components/services/ServiceCardSmall";
import { ServiceCardSmall } from "@/components/screen/global-components/services";
import { memo } from "react";

const chunkCards = (arr: ServiceCardSmallProps[], size: number) =>
  Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
    arr.slice(i * size, i * size + size)
  );

const ServicesTrustedExpertise =({
  variant = "standard",
}: ServicesTrustedExpertiseProps) => {
  const {
    cards,
    content: { title, description },
  } = servicesTrustedExpertisePropsMap[variant];

  const cardChunks = chunkCards(cards, 6);

  return (
    <section className="section overflow-hidden bg-background-secondary">
      <div className="container mx-auto py-12 lg:py-20">
        <div className="flex flex-col gap-4 md:justify-center md:gap-2 md:w-full md:max-w-[640] md:mx-auto md:text-center">
          <Typography variant="heading4">
            <h2>{title}</h2>
          </Typography>
          <div className="flex justify-center text-gray-600">
            <Typography variant="subHeadingSm" asChild>
              <p>{description}</p>
            </Typography>
          </div>
        </div>
        <Carousel.Mobile
          options={{
            slides: {
              spacing: 24,
              perView: "auto",
            },
          }}
          showPagination
          className="mt-6 md:!grid md:!grid-cols-3 md:!gap-4 lg:!mt-12 lg:!grid-cols-5 md:!overflow-visible"
        >
          {cardChunks.map((chunk, chunkIndex) => (
            <CarouselSlide
              key={`chunk-${chunkIndex}`}
              className="!min-w-full !w-full !md:min-w-auto md:!w-auto grid grid-cols-2 place-content-start gap-4 md:!contents md:!gap-0"
            >
              {chunk.map(
                ({ title, description, link, linkLabel, isStatic }, i) => (
                  <ServiceCardSmall
                    key={i}
                    title={title}
                    description={description}
                    link={link}
                    linkLabel={linkLabel}
                    isStatic={isStatic}
                  />
                )
              )}
            </CarouselSlide>
          ))}
        </Carousel.Mobile>
      </div>
    </section>
  );
}

export default memo(ServicesTrustedExpertise);
